import { ModalProps } from 'antd';
import { useGetApiSharingPartnerDetailQuery, useUpdateApiSharingPartnerMutation } from 'services';
import { ChangeCommonStatusModal, message } from 'components/common';

type ChangeApiSharingPartnerStatusModalProps = ModalProps & {
  apiSharingPartnerId: number;
  onClose?: () => void;
};

const ChangeApiSharingPartnerStatusModal = ({
  apiSharingPartnerId,
  onClose,
  ...props
}: ChangeApiSharingPartnerStatusModalProps) => {
  const { isLoading, data } = useGetApiSharingPartnerDetailQuery(apiSharingPartnerId);
  const [updateApiSharingPartner, { isLoading: isLoadingUpdate }] = useUpdateApiSharingPartnerMutation();

  const handleUpdateStatus = (status: boolean) => {
    updateApiSharingPartner({ apiSharingPartnerId: apiSharingPartnerId, isActive: status })
      .unwrap()
      .then((rs) => {
        message.systemSuccess(rs.message);
        onClose?.();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <ChangeCommonStatusModal
      {...props}
      onSubmit={handleUpdateStatus}
      loading={isLoading || isLoadingUpdate}
      value={data?.data.isActive}
    />
  );
};

export default ChangeApiSharingPartnerStatusModal;
